/**
 * Builds a stable selection key for an attachment, combining its `id` and
 * `fileId`. This replaces the previous parent/children array-index system so
 * selection survives reordering, scrolling and data refreshes.
 * @param {{ id?: string|number, fileId?: string }} attachment
 * @returns {string|null} `"${id}::${fileId}"`, or `null` when both are missing.
 */
export const getAttachmentSelectionKey = (attachment) => {
  if (!attachment) return null;
  const { id, fileId } = attachment;
  if (id == null && fileId == null) return null;
  return `${id ?? ""}::${fileId ?? ""}`;
};
